var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrawerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 9C7 8.44772 7.44772 8 8 8H24C24.5523 8 25 8.44772 25 9V9C25 9.55228 24.5523 10 24 10H8C7.44772 10 7 9.55228 7 9V9ZM7 16C7 15.4477 7.44772 15 8 15H24C24.5523 15 25 15.4477 25 16V16C25 16.5523 24.5523 17 24 17H8C7.44772 17 7 16.5523 7 16V16ZM7 23C7 22.4477 7.44772 22 8 22H24C24.5523 22 25 22.4477 25 23V23C25 23.5523 24.5523 24 24 24H8C7.44772 24 7 23.5523 7 23V23Z",
    fill: "#B4D4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerIcon);
export default __webpack_public_path__ + "static/media/drawerIcon.93af3ab99611907ed35b598d4203fc33.svg";
export { ForwardRef as ReactComponent };